import { getEntityRef } from "@client/content/lib/helper";
import { saveReview } from "@client/content/modules/ProductDetail/actions";
import { type ProductDetail } from "@client/content/modules/ProductDetail/types";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { localStateSelector } from "../../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeFieldsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const fieldsSelector = makeFieldsSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      formFields: fieldsSelector(state, props),

      isAdd: !localState.product?.userReview,
      status: localState.status,
      reviewError: localState.reviewError
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onSubmit: (data: ProductDetail.View.AddEditProductReview) => dispatch(saveReview(getEntityRef(props), data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
